import { render, staticRenderFns } from "./AsignacionRPQ.vue?vue&type=template&id=3f44a2dc&scoped=true"
import script from "./AsignacionRPQ.vue?vue&type=script&lang=js"
export * from "./AsignacionRPQ.vue?vue&type=script&lang=js"
import style0 from "./AsignacionRPQ.vue?vue&type=style&index=0&id=3f44a2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f44a2dc",
  null
  
)

export default component.exports